<div class="form-container">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-sm">
        <label for="type" translate>company.connectivity.details.equipment.form.type.label</label>
        <div ngbDropdown class="vox-dropdown-input dropdown equipment-type">
          <button class="dropdown__btn" id="type" ngbDropdownToggle type="button" [disabled]="types.length === 1">
            <span>{{selectedType.replace('_', ' ')}}</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="type">
            <button *ngFor="let t of types" [disabled]="t === selectedType" ngbDropdownItem class="dropdown__item"
              type="button" (click)="onChangeType(t)"><span>{{t.replace('_', ' ')}}</span></button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="selectedType === type.internet_key">
      <div class="row">
        <div class="col-sm">
          <label translate>company.connectivity.details.equipment.form.wifi_equipment_catalog_entry_id.label</label>
          <gdp-connectivity-entry-search [formControl]="form.controls['wifi_equipment_catalog_entry_id']"
            [type]="type.internet_key">
          </gdp-connectivity-entry-search>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="serial_number" translate>company.connectivity.details.equipment.form.serial_number.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('serial_number')}">
            <input class="vox-text-field" type="text" id="serial_number" formControlName="serial_number"
              [placeholder]="'company.connectivity.details.equipment.form.serial_number.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="number" translate>company.connectivity.details.equipment.form.number.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('number')}">
            <input class="vox-text-field" type="text" id="number" formControlName="number"
              [placeholder]="'company.connectivity.details.equipment.form.number.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="iccid" translate>company.connectivity.details.equipment.form.iccid.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('iccid')}">
            <input class="vox-text-field" type="text" id="iccid" formControlName="iccid"
              [placeholder]="'company.connectivity.details.equipment.form.iccid.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="pin" translate>company.connectivity.details.equipment.form.pin.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('pin')}">
            <input class="vox-text-field" type="text" id="pin" formControlName="pin"
              [placeholder]="'company.connectivity.details.equipment.form.pin.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="puk" translate>company.connectivity.details.equipment.form.puk.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('puk')}">
            <input class="vox-text-field" type="text" id="puk" formControlName="puk"
              [placeholder]="'company.connectivity.details.equipment.form.puk.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="activation_date"
            translate>company.connectivity.details.equipment.form.activation_date.label</label>
          <div class="vox-input-group vox-input-group_dense">
            <gdp-date-picker formControlName='activation_date' [maxDate]="startDay"></gdp-date-picker>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="imei" translate>company.connectivity.details.equipment.form.imei.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('imei')}">
            <input class="vox-text-field" type="text" id="imei" formControlName="imei"
              [placeholder]="'company.connectivity.details.equipment.form.imei.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span *ngIf="form.get('imei').errors && form.get('imei').errors.required"
              class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
            <span *ngIf="form.get('imei').errors && form.get('imei').errors.pattern"
              class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.imei-pattern</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="status" translate>company.connectivity.details.equipment.form.status.label</label>
          <div ngbDropdown class="vox-dropdown-input dropdown">
            <button class="dropdown__btn" id="status" [disabled]="statuses.length === 1" type="button"
              ngbDropdownToggle>
              <span>{{form.value.status}}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="type">
              <button *ngFor="let status of statuses" ngbDropdownItem class="dropdown__item" type="button"
                (click)="onChangeStatus(status)"><span>{{status}}</span></button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedType === type.modem_router">
      <div class="row">
        <div class="col-sm">
          <label translate>company.connectivity.details.equipment.form.wifi_equipment_catalog_entry_id.label</label>
          <gdp-connectivity-entry-search [formControl]="form.controls['wifi_equipment_catalog_entry_id']"
            [type]="type.modem_router">
          </gdp-connectivity-entry-search>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label for="mac_address" translate>company.connectivity.details.equipment.form.mac_address.label</label>
          <div class="vox-input-group vox-input-group_dense"
            [ngClass]="{'vox-input-group_invalid': isFieldValid('mac_address')}">
            <input class="vox-text-field" type="text" id="mac_address" formControlName="mac_address"
              [placeholder]="'company.connectivity.details.equipment.form.mac_address.placeholder' | translate" />
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span *ngIf="form.get('mac_address').errors && form.get('mac_address').errors.required"
              class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.required</span>
            <span *ngIf="form.get('mac_address').errors && form.get('mac_address').errors.pattern"
              class="vox-input-group__error-message"
              translate>company.connectivity.details.equipment.form.error.mac_address-pattern</span>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="submit-container">
      <button class="vox-btn vox-btn-primary" [disabled]="form.invalid" type="submit" [ladda]="loading"
        data-spinner-color="grey" data-style="zoom-in">
        {{ equipment

        ? ('company.connectivity.details.equipment.form.submit.update' | translate)

        : ('company.connectivity.details.equipment.form.submit.create' | translate)

        }}</button>
    </div>
  </form>
</div>